export default __webpack_public_path__ + "static/media/profile.59f19111.svg";